<template>
    <div>
        <div class="row">
            <div class="col-md-12 col-sm-12 ">
                <div class="x_content">
                    <div class="x_panel">
                        <h2 class="float-left">Location Wise Stock Report </h2>
                        <div class="float-right">
                            <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                            <template v-if="stockLedgerData && !loading && isPermissionExist(PERMISSIONS.LOCATION_WISE_STOCK_REPORT_PRINT)">
                              <button
                                @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                                <i class="fa fa-print" v-if="!isPrinting"></i>
                                <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                                {{ isPrinting ? 'Printing...' : 'Print' }}
                              </button>
                              <vue-excel-xlsx
                                ref="excel"
                                :data="excelData"
                                :columns="excelHeader"
                                :file-name="'Location Wise Stock Report'"
                                :file-type="'xlsx'"
                                :sheet-name="'sheetname'"
                                :disabled="isPrinting"
                                class="btn btn-primary btn-sm float-right"
                              >
                                <div
                                  @click.prevent="handleExportPrint('excel')"
                                >
                                  <i class="fa fa-file-excel-o"></i>
                                  {{ isPrinting ? 'Preparing...' : 'Excel' }}
                                </div>
                              </vue-excel-xlsx>
                            </template>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">

                            <div class="x_panel">
                                <div class="x_content">
                                    <div class="row justify-content-center">

                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label>Select Location</label>
                                                <select class="form-control location-tree" v-model="location_id">
                                                    <option value="" selected>Select location</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <button style="margin-top: 26px" @click="getData()" class="btn btn-success btn-sm">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
                                <PulseLoader :loading="loading"></PulseLoader>
                            </div>

                            <div class="card-box table-responsive" v-if="stockLedgerData && !loading">
                                <div id="printableArea">
                                    <div class="mb-3 text-center">
                                        <div class="font-weight-bold">Location Wise Stock Report</div>
                                        <div>Location: <span class="location">{{location_name}}</span></div>
                                    </div>
                                    <TableData
                                            :stockLedgerData="stockLedgerData.data"
                                            :currentPage="Number(stockLedgerData?.current_page)"
                                            :perPage="Number(stockLedgerData?.per_page)"
                                            :noDataFound="noDataFound"
                                    />
                                </div>
                            </div>

                            <Pagination :pagination="stockLedgerData" :getData="getData"/>

                            <div id="printArea" style="display: none">
                                <div style="text-align: center">
                                    <h2 style="line-height: 10px;">{{ appName }}</h2>
                                    <h4 style="line-height: 10px;">Vessel Name: {{this.vessel_name}}</h4>
                                    <h3 style="line-height: 10px;">Stock Ledger Report</h3>
                                    <h3 style="line-height: 10px;">Location: <span class="location">{{location_name}}</span></h3>
                                    <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                </div>
                                <TableData :stockLedgerData="printItems" :isPrinting="true" :noDataFound="noDataFound"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import datetime from 'vuejs-datetimepicker'
    import auth from '../../../auth'
    import TableData from "./TableData.vue";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import {apiPrintData} from "@/utils/print";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        components: {TableData, datetime, PulseLoader, Pagination},
        data() {
            return {
                loading: false,
                noDataFound: false,
                offset: 20,
                isPrinting: false,
                locations: null,
                location_id: null,
                location_name: null,
                vessel_name: auth.getVesselName(),
                permissions: auth.getPermissionData(),
                item: null,
                CategoriesItemData: null,
                appName: process.env.VUE_APP_NAME,
                portData: null,
                stockLedgerData: null,
                stockOpeningData: null,
                stockClosingData: null,
                vesselId: auth.getVesselId(),
                printItems: [],
                excelHeader: [],
                excelData: [],
            }
        },
        mounted() {
            this.getLocations();
        },
        methods: {
            getLocations() {
                this.$http.get('/api/locationTree/' + this.vesselId).then(response => {
                    this.locations = response.data;
                    $('.location-tree').html(this.locations)
                }).catch(e => {
                    console.log(e)
                });
            },
            getData(page = 1) {

                this.noDataFound = false;
                this.location_name = $('.location-tree option:selected').text();

                let params = {
                    'location_id': this.location_id,
                    'vessel_id': this.vesselId,
                    page: page,
                    is_all: 0,
                    offset: this.offset
                };

                if (this.location_id === null || this.location_id === 'undefined' || this.location_id.trim().length === 0) {
                    this.$snotify.error('Please fill required field');
                    this.location_id = null;
                    return false;
                }

                this.loading = true;
                this.$http.get('/api/report/location-wise-stock', {params}).then((response) => {
                    this.loading = false;
                    this.stockLedgerData = response.data.success;
                    if (this.stockLedgerData?.data.length < 1) {
                        this.noDataFound = true;
                    }
                }).catch((error) => {
                    this.loading = false;
                    let response = error.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        this.$snotify.error('Something went wrong');
                    }
                })
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Item name': `${item?.name || ''}`,
                'Impa code': `${item?.inpa_code || ''}`,
                'Model': `${item?.model || ''}`,
                'Maker': `${item?.maker || ''}`,
                'Maker Part No': `${item?.maker_part_no || ''}`,
                'Drawing': `${item?.drawing || ''}`,
                'Other Ref': `${item?.other_ref || ''}`,
                'Opening Stock': `${item?.opening_stock || ''}`,
                'Stock In Total': `${item?.inTotal || ''}`,
                'Stock Out Total': `${item?.OutTotal || ''}`,
                'Closing Balance': `${item?.closing_stock || ''}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                'location_id': this.location_id,
                'vessel_id': this.vesselId,
                is_all: 1,
              };

              const res = await this.$http.get('/api/report/location-wise-stock', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Location Wise Stock Report');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
        }
    }
</script>
